var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{attrs:{"label":"值","prop":_vm.field.prop,"rules":_vm.field.rule}},[_c('el-input',{staticClass:"value-input",attrs:{"placeholder":"请输入值"},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }